import type { Component } from "vue";
import type { RouteRecordRaw, RouteRecordRedirectOption } from "vue-router";

import {
  routeManifest,
  type RedirectContract,
  type RouteDescriptor,
  type RouteView,
} from "./manifest";

const viewLoaders: Readonly<Record<RouteView, () => Promise<Component>>> = {
  RootView: () => import("../views/RootView.vue"),
  HomeView: () => import("../views/HomeView.vue"),
  LoginView: () => import("../views/LoginView.vue"),
  RegisterView: () => import("../views/RegisterView.vue"),
  VerifyView: () => import("../views/VerifyView.vue"),
  ClaimView: () => import("../views/ClaimView.vue"),
  FundView: () => import("../views/FundView.vue"),
  ResetPasswordView: () => import("../views/ResetPasswordView.vue"),
  SubjectView: () => import("../views/SubjectView.vue"),
  AccountView: () => import("../views/AccountView.vue"),
  PhoneCaptureView: () => import("../views/PhoneCaptureView.vue"),
  PrivacyView: () => import("../views/PrivacyView.vue"),
  TermsView: () => import("../views/TermsView.vue"),
  AdminDashboard: () => import("../views/AdminDashboard.vue"),
  AdminCourseDetail: () => import("../views/AdminCourseDetail.vue"),
  AdminProductStats: () => import("../views/AdminProductStats.vue"),
  PurchaseSuccessView: () => import("../views/PurchaseSuccessView.vue"),
};

function redirectFor(redirect: RedirectContract): RouteRecordRedirectOption {
  if (redirect.kind === "static") return redirect.to;
  return (to) => {
    const path = `/subjects/${String(to.params.subjectId)}`;
    return redirect.suffix === undefined ? path : `${path}${redirect.suffix}`;
  };
}

function routeRecord(descriptor: RouteDescriptor): RouteRecordRaw {
  if (descriptor.kind === "redirect") {
    return {
      path: descriptor.path,
      redirect: redirectFor(descriptor.redirect),
    };
  }

  return {
    path: descriptor.path,
    name: descriptor.name,
    component: viewLoaders[descriptor.view],
    ...(descriptor.props === undefined ? {} : { props: descriptor.props }),
    ...(descriptor.meta === undefined ? {} : { meta: descriptor.meta }),
  };
}

export function createManifestRoutes(): RouteRecordRaw[] {
  return routeManifest.map(routeRecord);
}
